export const LOGOUT_TRIGGER = 'LOGOUT_TRIGGER';
export const LOGOUT_API_REQUEST = 'LOGOUT_API_REQUEST';
export const LOGOUT_API_SUCCESS = 'LOGOUT_API_SUCCESS';
export const LOGOUT_API_FAILURE = 'LOGOUT_API_FAILURE';
